/**
 * Helper to Get date by using the current locale.
 */
export function getDate(date: number | string | Date, hideYear = false) {
  const localeDate = new Date(date).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: hideYear ? undefined : 'numeric',
  })

  return localeDate
}

/**
 * Helper to Get time by using the current locale.
 */
export function getTime(date: number | string | Date) {
  const localeTime = new Date(date).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  })

  return localeTime
}

/**
 * Helper to Get time for today or date by using the current locale.
 */
export function getDateTime(date: number | string | Date) {
  const currentYear = new Date().getFullYear() === new Date(date).getFullYear()
  const localeDate = getDate(date, currentYear)
  const localeTodayDate = getDate(new Date(), currentYear)

  if (localeDate === localeTodayDate) {
    return getTime(date)
  } else {
    return localeDate
  }
}

/**
 * Helper to Get timestamp since the selected month.
 */
export function getTimestamp(monthCount: number) {
  const seconds = 2628000 * monthCount

  return Math.floor(Date.now() / 1000) - seconds
}
